import React from "react";
import DOMPurify from "dompurify";
import { useSelector } from 'react-redux'

const AnswerWidget = ({ payload }) => {
  const language = useSelector((state) => state.language.language)
  const cleanHtml = DOMPurify.sanitize(payload?.answer?.[language]);

  return (
    <div
      style={{ color: "#434343" }}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default AnswerWidget;
